
// import React, { useEffect, useRef, useState } from 'react'
//   const Dots = ({ currentPage , setCurrentPage , onClickDotEvent}) => {
//     const Dot = ({ num, currentPage }) => {
//       return (
//         <div className={ currentPage === num ? 'dot_style black ' : 'dot_style' }
//           // style={{
//           //   width: 15,
//           //   height: 15,
//           //   border: "1px solid black",
//           //   borderRadius: 999,
//           //   backgroundColor: currentPage === num ? "black" : "transparent",
//           //   transitionDuration: 1000,
//           //   transition: "background-color 0.5s",
//           // }}
//           onClick={()=>onClickDotEvent(num)}
//         />
//       );
//     };
//     // const outerDivRef = useRef();
//     // const DIVIDER_HEIGHT = 5;
    
//     // const onClickDotEvent = (e) => {
//     //   const viewHeight = window.innerHeight;
//     //   console.log("눌림", viewHeight, e, viewHeight * (e-1) + DIVIDER_HEIGHT * (e-1));
//     //   outerDivRef.current.scrollTo({
//     //     top: viewHeight * (e-1) + DIVIDER_HEIGHT * (e-1),
//     //     left: 0,
//     //     behavior: "smooth",
//     //   });
//     //   setCurrentPage(e);
//     // }
//     return (
//       <div className='slide_navigation'
//       //  style={{ position: "fixed", top: "50%", right: 100 }}
//        >
//         <div className='dot_nav'
//           // style={{
//           //   display: "flex",
//           //   flexDirection: "column",
//           //   justifyContent: "space-between",
//           //   alignItems: "center",
//           //   width: 20,
//           //   height: 128,
//           // }}
//         >
//           <Dot num={1} currentPage={currentPage} setCurrentPage={setCurrentPage}></Dot>
//           <Dot num={2} currentPage={currentPage} setCurrentPage={setCurrentPage}></Dot>
//           <Dot num={3} currentPage={currentPage} setCurrentPage={setCurrentPage}></Dot>
//           <Dot num={4} currentPage={currentPage} setCurrentPage={setCurrentPage}></Dot>
//           <Dot num={5} currentPage={currentPage} setCurrentPage={setCurrentPage}></Dot>
//           <Dot num={6} currentPage={currentPage} setCurrentPage={setCurrentPage}></Dot>
//         </div>
//       </div>
//     );
//   };
  
//   export default Dots;
  
import React from 'react';

const Dots = ({ currentPage, onClickDotEvent }) => {
  const Dot = ({ num }) => {
    return (
      <>
      <div
        className={currentPage === num ? 'dot_border black' : 'dot_border'}
        onClick={() => onClickDotEvent(num)} 
      >
        <div
        className={currentPage === num ? 'dot_style black' : 'dot_style'}
        onClick={() => onClickDotEvent(num)}
        // style={{
        //   width: 15,
        //   height: 15,
        //   border: "1px solid black",
        //   borderRadius: "50%",
        //   backgroundColor: currentPage === num ? "black" : "transparent",
        //   transition: "background-color 0.5s",
        //   cursor: "pointer",
        // }}
      />
      </div>
      </>
      
    );
  };

  return (
    <div className='slide_navigation'>
      <div className='dot_nav' 
      // style={{
      //   display: "flex",
      //   flexDirection: "column",
      //   justifyContent: "space-between",
      //   alignItems: "center",
      //   width: 20,
      //   height: 128,}}
        >
        {[...Array(6)].map((_, index) => (
          <Dot key={index} num={index + 1} />
        ))}
      </div>
    </div>
  );
};

export default Dots;